import config from './env-config.json' with {type: 'json'};

const formatUrl = (host, port, tls) => {
    return 'http' + (tls ? 's' : '') + '://' + host + (port ? ':' + port : '') + '/';
}

export const UI_HOST = config.ui.host;
export const UI_PORT = config.ui.port;
export const WEB_ROOT = formatUrl(config.ui.host, config.ui.port, config.ui.tls);
export const API_URL = formatUrl(config.api.host, config.api.port, config.api.tls);
